<ng-container *ngIf="!viewBox && !attribute">
  <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>

<ng-container *ngIf="!viewBox && attribute">
  <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width"
       IconSpriteAttr [attribute]="attribute">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>

<ng-container *ngIf="viewBox && !attribute">
    <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width"
       [attr.viewBox]="viewBox"
       [attr.preserveAspectRatio]="preserveAspectRatio">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>

<ng-container *ngIf="viewBox && attribute">
    <svg [attr.class]="classes"
       [attr.width]="width"
       [attr.height]="height || width"
       [attr.viewBox]="viewBox"
       [attr.preserveAspectRatio]="preserveAspectRatio"
       IconSpriteAttr [attribute]="attribute">
    <use [attr.xlink:href]="src"></use>
  </svg>
</ng-container>
